export enum INPUT_TEXT_TYPES {
  EMAIL = 'email',
  PASSWORD = 'password',
  TEXT = 'text',
  URL = 'url',
  NUMBER = 'number',
  SEARCH = 'search',
}

export enum VARIANTS {
  FOCUS = 'focus',
  HOVER = 'hover',
  HAS_ERROR = 'has-error',
  READ_ONLY = 'read-only',
}
